var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteeringWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#647A97",
    d: "M0 7a7 7 0 107-7 7.008 7.008 0 00-7 7zm8.668 4.9a20.48 20.48 0 01-.444-3.155s1.338-.34 3.8-.498A5.197 5.197 0 018.668 11.9zM8.167 7a.584.584 0 11-1.168-.002A.584.584 0 018.167 7zm3.857-1.247c-2.463-.159-3.8-.498-3.8-.498.066-1.062.214-2.117.444-3.155a5.193 5.193 0 013.356 3.653zM5.834 7a15.23 15.23 0 00.925 5.171 5.176 5.176 0 01.038-10.343A14.7 14.7 0 005.833 7z"
  })));
}
export default SvgSteeringWheel;